import { STATEMENT_SCORE } from "../config";
import { Analysis } from "../resume-analysis/resume-analyse-types";



export const getStatementScore = (descriptionAnalysis: Analysis, maxScoreOfSection: number) => {

  // console.log("ends with period" ,descriptionAnalysis.endsWithPeriod)

  const grammerMistakeScore = descriptionAnalysis.grammarMistakes?.length > 0 ? 0 : STATEMENT_SCORE.grammarMistake * maxScoreOfSection;
  const spellingMistakeScore = descriptionAnalysis.spellingMistakes?.length > 0 ? 0 : STATEMENT_SCORE.spellingMistake * maxScoreOfSection;
  const buzzWordsScore = descriptionAnalysis.buzzWords?.length > 0 ? 0 : STATEMENT_SCORE.buzzWords * maxScoreOfSection;
  const fillerWordsScore = descriptionAnalysis.fillerWords?.length > 0 ? 0 : STATEMENT_SCORE.fillerWords * maxScoreOfSection;
  const endsWithPeriodScore = descriptionAnalysis.endsWithPeriod !== 0 ? STATEMENT_SCORE.endsWithPeriod * maxScoreOfSection : 0;
  const passiveVoiceScore = descriptionAnalysis.isPassiveVoice == 1 ? 0 : STATEMENT_SCORE.passiveVoice * maxScoreOfSection;
  const personalPronounsScore = descriptionAnalysis.personalPronouns?.length > 0 ? 0 : STATEMENT_SCORE.personalPronouns * maxScoreOfSection;

  let weakVerbScore = STATEMENT_SCORE.weakVerb * maxScoreOfSection;
  let pastTenseScore = STATEMENT_SCORE.pastTense * maxScoreOfSection;

  descriptionAnalysis.actionVerbAnalysis.forEach((verbAnalysis) => {

    if (verbAnalysis.isWeakVerb === 1) {
      weakVerbScore = 0;
    }

    if (verbAnalysis.isPastTense === 0) {
      pastTenseScore = 0;
    }
  }
  );

  const totalStatementScore = grammerMistakeScore + spellingMistakeScore + buzzWordsScore + fillerWordsScore + endsWithPeriodScore + passiveVoiceScore + personalPronounsScore + weakVerbScore + pastTenseScore;

  

  // if(totalStatementScore > 8 ){
  //   console.log("statement score details", {
  //   totalStatementScore,
  //   grammerMistakeScore,
  //   spellingMistakeScore,
  //   buzzWordsScore,
  //   fillerWordsScore,
  //   endsWithPeriodScore,
  //   passiveVoiceScore,
  //   personalPronounsScore,
  //   weakVerbScore,
  //   pastTenseScore
  // })
  // console.log("description analysis", descriptionAnalysis)
  // }
  return {
    totalScore: Math.min(totalStatementScore, maxScoreOfSection),
    grammerMistakeScore,
    spellingMistakeScore,
    buzzWordsScore,
    fillerWordsScore,
    endsWithPeriodScore,
    passiveVoiceScore,
    personalPronounsScore,
    weakVerbScore,
    pastTenseScore
  }


}
